import { DetailSection } from '@command-center/ui-system';
import { intakeRecordRoute } from '../lib/intake-routes';
import type { IntakeItem } from '../lib/leadloop-api';
import { formatDateTime } from '../views/parts';
import { RelatedRecordList } from './record-detail-panels';

/**
 * The calls and form entries behind a record.
 *
 * The section heading already says what these are; the sentence that used to
 * sit under it explained the same thing again in longer words.
 */
export function LinkedIntakeRecords({ items }: { items: IntakeItem[] }) {
  return (
    <DetailSection title="Calls and Form Entries">
      <RelatedRecordList
        empty="No calls or form entries are linked to this record."
        items={items.map((item) => ({
          id: item.id,
          to: intakeRecordRoute(item.sourceType, item.sourceId),
          title: item.displayName ?? (item.sourceType === 'call' ? 'Unknown caller' : 'Form entry'),
          subtitle: item.summary ?? (item.sourceType === 'call' ? 'Voice call' : 'Form entry'),
          meta: formatDateTime(item.occurredAt ?? item.createdAt),
        }))}
      />
    </DetailSection>
  );
}
